<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

@if (iconOnly) {
	<button
		[type]="type"
		mat-icon-button
		[ngClass]="{ small: size === 'small', large: size === 'large', 'icon-only': iconOnly }"
		[disabled]="disabled"
		(click)="handleClick.emit()"
	>
		<span
			[globalictccBadge]="hasBadge"
			[ngClass]="[buttonClass, 'icon-' + iconName]"
		></span>
	</button>
} @else {
	<button
		[type]="type"
		mat-button
		[ngClass]="[buttonClass]"
		[disabled]="disabled"
		(click)="handleClick.emit()"
	>
		@if (iconPosition === "left" && iconName) {
			<span [ngClass]="['icon-' + iconName]"></span>
		}

		<span
			[globalictccBadge]="hasBadge"
			class="button-text"
		>
			{{ label }}
		</span>

		@if (iconPosition === "right" && iconName) {
			<span [ngClass]="['icon-' + iconName]"></span>
		}
	</button>
}
